import React, { Suspense } from 'react';
import { Loading } from 'components';


const ThemeSuspense = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default ThemeSuspense;
